import Vue from "vue";
import Router from "vue-router";
import { getToken } from "../utils/auth";
import { hasPermission } from "../utils/auth"
import { gameRoute } from './game'
import { configRoute } from './config'
import { systemRoute } from './system'
import { userRoute } from './user'
import { advRoute } from './adv'
import { funnelRoute } from './funnel'

Vue.use(Router);

export const constantRoutes = [
  gameRoute,
  configRoute,
  systemRoute,
  userRoute,
  advRoute,
  funnelRoute,
  {
    path: '/redirect',
    component: resolve => require(["@/components/index"], resolve),
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/components/redirect/index')
      }
    ]
  },
  {
    path: "/login",
    component: resolve => require(["@/components/login"], resolve)
  },
  {
    path: "/404",
    component: resolve => require(["@/components/404"], resolve)
  },
  {
    path: "/",
    name: "首页",
    meta: { title: "首页", affix: true },
    component: resolve => require(["@/components/index"], resolve),
  },
  {
    path: "/adv/interval",
    component: resolve => require(["@/components/adv/advInterval"], resolve)
  },
  {
    path: "/game/tycoon/user_detail",
    component: resolve =>
      require(["@/components/game/tycoon/TycoonUserDetail"], resolve)
  },
  {
    path: "/system",
    name: "系统数据",
    component: resolve => require(["@/components/index"], resolve),
    children: [
      {
        path: "user",
        name: "用户管理",
        component: resolve => require(["@/components/system/user"], resolve),
        meta: { title: "用户管理" }
      },
      {
        path: "role",
        name: "角色管理",
        component: resolve => require(["@/components/system/role"], resolve),
        meta: { title: "角色管理" }
      },
      {
        path: "job",
        name: "定时任务管理",
        component: resolve =>
          require(["@/components/system/job"], resolve),
        meta: { title: "定时任务管理" }
      },
    ]
  },
]

const router = new Router({
  mode: "history",
  base: "/cms/",
  routes: constantRoutes

});

//判断是否有权限
let allowPath = [
  "/",
  "/login",
  "/404",
  "/adv/interval",
  "/game/tycoon/user_detail",
  "/system/update_log"
];
router.beforeEach((to, from, next) => {
  let token = getToken()
  if (allowPath.indexOf(to.path) > -1) {
    next();
  } else if (to.path.startsWith("/redirect")) {
    next();
  } else if (token == null) {
    // 判断是否登录
    // 记录上次地址
    if (router.currentRoute.fullPath != '/login') {
      localStorage.setItem("lastPath", router.currentRoute.fullPath)
    }
    next({ path: "/login" });
  } else if (to.path == '/') {
    next();
  } else {
    // 判断是否有权限
    if (hasPermission(to.fullPath)) {
      next();
    } else {
      next({ path: "/404" });
    }
  }
});

// 路由跳转相同异常捕获
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js